<script setup lang="ts">
import FiatTransactionsListContainer from './containers/FiatTransactionsListContainer.vue'
</script>

<template>
  <FiatTransactionsListContainer />
</template>
